<template>
	<section>
		<plan-form
			:code-plan="codePlan"
			:id-plan="idPlan"
			:users="users"
			:code-project="codeProject"/>
	</section>
</template>

<script>
	import actionSidebar from '@/components/shared/action-sidebar';
	import planForm from '@/components/plans/plan-form';

	function data() {
		return {
			roles: [],
			users: [],
		};
	}

	export default {
		name: 'page-new-plan',
		components: {
			actionSidebar,
			planForm,
		},
		data,
		props: {
			codeProject: {
				type: String,
			},
			codePlan: {
				type: String,
			},
			idPlan: {
				type: [Number, String],
			},
			namePlan: {
				type: String,
			},
		},
	};
</script>



// WEBPACK FOOTER //
// src/pages/plans/page-plan-new.vue